import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Check, Calendar, Clock, BookOpen, ChevronDown, ChevronUp } from 'lucide-react';
export function CoursesPage() {
  const [openAccordion, setOpenAccordion] = useState<number | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const toggleAccordion = (index: number) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };
  return <main className="bg-white min-h-screen font-sans text-ink" data-id="element-316">
      <Header data-id="element-317" />

      {/* HERO SECTION */}
      <section className="pt-32 pb-16 container mx-auto px-6 md:px-12 text-center" data-id="element-318">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-319">
          <h1 className="font-heading text-5xl md:text-6xl font-semibold tracking-tight text-ink mb-6" data-id="element-320">
            Стань майстром
          </h1>
          <p className="text-muted text-lg md:text-xl font-normal leading-relaxed max-w-2xl mx-auto mb-12" data-id="element-321">
            Авторські курси перукарського мистецтва та нігтьового сервісу. 300+
            випускників, що вже працюють у професії.
          </p>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm md:text-base font-semibold tracking-wide uppercase text-ink" data-id="element-322">
            <span data-id="element-323">300+ ВИПУСКНИКІВ</span>
            <span className="hidden md:block w-px h-4 bg-line" data-id="element-324"></span>
            <span data-id="element-325">12+ РОКІВ ДОСВІДУ</span>
            <span className="hidden md:block w-px h-4 bg-line" data-id="element-326"></span>
            <span data-id="element-327">5к+ КЛІЄНТІВ</span>
          </div>
        </motion.div>
      </section>

      {/* COURSES LIST */}
      <section className="py-16 container mx-auto px-6 md:px-12 max-w-4xl space-y-32" data-id="element-328">
        {/* COURSE 1: Перукар чоловічих стрижок */}
        <div className="space-y-12" data-id="element-329">
          <div className="text-center" data-id="element-330">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-ink mb-8" data-id="element-331">
              Перукар чоловічих стрижок
            </h2>
            <div className="w-full h-[300px] md:h-[400px] bg-surface rounded-[2rem] border border-line flex items-center justify-center mb-8" data-id="element-332">
              <span className="text-muted font-medium tracking-widest uppercase text-sm" data-id="element-333">
                Фото процесу
              </span>
            </div>
            <p className="bg-surface p-8 rounded-[2rem] text-muted text-lg leading-relaxed border border-line" data-id="element-334">
              Курс охоплює всі техніки чоловічих стрижок — від класичних до
              сучасних барберських технік. Навчання у форматі міні-груп.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-335">
            <div className="border border-line rounded-[2rem] p-8 text-center flex flex-col justify-center" data-id="element-336">
              <p className="text-muted font-medium uppercase tracking-widest text-xs mb-4" data-id="element-337">
                Повна оплата
              </p>
              <p className="font-heading text-4xl font-bold text-ink mb-2" data-id="element-338">
                15 000 грн
              </p>
              <p className="text-muted text-sm" data-id="element-339">одноразово</p>
            </div>
            <div className="bg-ink rounded-[2rem] p-8 text-center flex flex-col justify-center text-white shadow-xl" data-id="element-340">
              <p className="text-gray-400 font-medium uppercase tracking-widest text-xs mb-4" data-id="element-341">
                Розстрочка
              </p>
              <p className="font-heading text-4xl font-bold mb-2" data-id="element-342">5 000 грн</p>
              <p className="text-gray-400 text-sm" data-id="element-343">на місяць / 1–3 міс</p>
            </div>
          </div>

          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-344">
            <div className="grid md:grid-cols-3 gap-6 mb-8 pb-8 border-b border-line" data-id="element-345">
              <div className="flex items-center gap-4" data-id="element-346">
                <Calendar className="text-ink" size={24} data-id="element-347" />
                <div data-id="element-348">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-349">
                    Тривалість
                  </p>
                  <p className="font-semibold text-ink" data-id="element-350">3 місяці</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-351">
                <BookOpen className="text-ink" size={24} data-id="element-352" />
                <div data-id="element-353">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-354">
                    Кількість занять
                  </p>
                  <p className="font-semibold text-ink" data-id="element-355">36</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-356">
                <Clock className="text-ink" size={24} data-id="element-357" />
                <div data-id="element-358">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-359">
                    Тривалість уроку
                  </p>
                  <p className="font-semibold text-ink" data-id="element-360">1.5–2 години</p>
                </div>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-361">
              {['Практика на моделях', 'Усі інструменти надаються', 'Сертифікат після завершення', 'Підтримка після курсу'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-362">
                  <Check className="text-ink" size={18} strokeWidth={3} data-id="element-363" />
                  <span className="text-ink font-medium" data-id="element-364">{item}</span>
                </li>)}
            </ul>
          </div>

          <a href="#contact" className="block w-full py-4 bg-ink text-white text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-black transition-all duration-300 shadow-lg" data-id="element-365">
            Записатися на курс
          </a>
        </div>

        <div className="w-full h-px bg-line" data-id="element-366"></div>

        {/* COURSE 2: Перукар жіночих стрижок */}
        <div className="space-y-12" data-id="element-367">
          <div className="text-center" data-id="element-368">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-ink mb-8" data-id="element-369">
              Перукар жіночих стрижок
            </h2>
            <div className="w-full h-[300px] md:h-[400px] bg-surface rounded-[2rem] border border-line flex items-center justify-center mb-8" data-id="element-370">
              <span className="text-muted font-medium tracking-widest uppercase text-sm" data-id="element-371">
                Фото процесу
              </span>
            </div>
            <p className="bg-surface p-8 rounded-[2rem] text-muted text-lg leading-relaxed border border-line" data-id="element-372">
              Опануйте всі техніки жіночих стрижок — каре, боб, каскад, модельні
              стрижки. Від базових до складних форм.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-373">
            <div className="border border-line rounded-[2rem] p-8 text-center flex flex-col justify-center" data-id="element-374">
              <p className="text-muted font-medium uppercase tracking-widest text-xs mb-4" data-id="element-375">
                Повна оплата
              </p>
              <p className="font-heading text-4xl font-bold text-ink mb-2" data-id="element-376">
                15 000 грн
              </p>
              <p className="text-muted text-sm" data-id="element-377">одноразово</p>
            </div>
            <div className="bg-ink rounded-[2rem] p-8 text-center flex flex-col justify-center text-white shadow-xl" data-id="element-378">
              <p className="text-gray-400 font-medium uppercase tracking-widest text-xs mb-4" data-id="element-379">
                Розстрочка
              </p>
              <p className="font-heading text-4xl font-bold mb-2" data-id="element-380">5 000 грн</p>
              <p className="text-gray-400 text-sm" data-id="element-381">на місяць / 1–3 міс</p>
            </div>
          </div>

          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-382">
            <div className="grid md:grid-cols-2 gap-6 mb-8 pb-8 border-b border-line" data-id="element-383">
              <div className="flex items-center gap-4" data-id="element-384">
                <Calendar className="text-ink" size={24} data-id="element-385" />
                <div data-id="element-386">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-387">
                    Тривалість
                  </p>
                  <p className="font-semibold text-ink" data-id="element-388">3 місяці</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-389">
                <Clock className="text-ink" size={24} data-id="element-390" />
                <div data-id="element-391">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-392">
                    Тривалість уроку
                  </p>
                  <p className="font-semibold text-ink" data-id="element-393">1.5–2 години</p>
                </div>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-394">
              {['Практика на моделях', 'Усі інструменти надаються', 'Сертифікат після завершення', 'Підтримка після курсу'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-395">
                  <Check className="text-ink" size={18} strokeWidth={3} data-id="element-396" />
                  <span className="text-ink font-medium" data-id="element-397">{item}</span>
                </li>)}
            </ul>
          </div>

          <a href="#contact" className="block w-full py-4 bg-ink text-white text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-black transition-all duration-300 shadow-lg" data-id="element-398">
            Записатися на курс
          </a>
        </div>

        <div className="w-full h-px bg-line" data-id="element-399"></div>

        {/* COURSE 3: Чол. + жін. */}
        <div className="space-y-12" data-id="element-400">
          <div className="text-center" data-id="element-401">
            <span className="inline-block px-4 py-1.5 bg-ink text-white text-xs font-semibold tracking-widest uppercase rounded-full mb-6" data-id="element-402">
              Комбінований курс
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-ink mb-8" data-id="element-403">
              Перукар чоловічих та жіночих стрижок
            </h2>
            <div className="w-full h-[300px] md:h-[400px] bg-surface rounded-[2rem] border border-line flex items-center justify-center mb-8" data-id="element-404">
              <span className="text-muted font-medium tracking-widest uppercase text-sm" data-id="element-405">
                Фото процесу
              </span>
            </div>
            <p className="bg-surface p-8 rounded-[2rem] text-muted text-lg leading-relaxed border border-line" data-id="element-406">
              Повна програма — чоловічі та жіночі стрижки в одному курсі.
              Ідеально для тих, хто хоче одразу опанувати обидва напрямки.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-407">
            <div className="border border-line rounded-[2rem] p-8 text-center flex flex-col justify-center" data-id="element-408">
              <p className="text-muted font-medium uppercase tracking-widest text-xs mb-4" data-id="element-409">
                Повна оплата
              </p>
              <p className="font-heading text-4xl font-bold text-ink mb-2" data-id="element-410">
                21 000 грн
              </p>
              <p className="text-muted text-sm" data-id="element-411">одноразово</p>
            </div>
            <div className="bg-ink rounded-[2rem] p-8 text-center flex flex-col justify-center text-white shadow-xl" data-id="element-412">
              <p className="text-gray-400 font-medium uppercase tracking-widest text-xs mb-4" data-id="element-413">
                Розстрочка
              </p>
              <p className="font-heading text-4xl font-bold mb-2" data-id="element-414">7 000 грн</p>
              <p className="text-gray-400 text-sm" data-id="element-415">на місяць / 1–3 міс</p>
            </div>
          </div>

          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-416">
            <div className="grid md:grid-cols-3 gap-6 mb-8 pb-8 border-b border-line" data-id="element-417">
              <div className="flex items-center gap-4" data-id="element-418">
                <Calendar className="text-ink" size={24} data-id="element-419" />
                <div data-id="element-420">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-421">
                    Тривалість
                  </p>
                  <p className="font-semibold text-ink" data-id="element-422">3 місяці</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-423">
                <BookOpen className="text-ink" size={24} data-id="element-424" />
                <div data-id="element-425">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-426">
                    Кількість занять
                  </p>
                  <p className="font-semibold text-ink" data-id="element-427">36</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-428">
                <Clock className="text-ink" size={24} data-id="element-429" />
                <div data-id="element-430">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-431">
                    Тривалість уроку
                  </p>
                  <p className="font-semibold text-ink" data-id="element-432">2–2.5 години</p>
                </div>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-433">
              {['Чоловічі та жіночі техніки', 'Практика на моделях', 'Усі інструменти надаються', 'Сертифікат після завершення', 'Підтримка після курсу'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-434">
                  <Check className="text-ink" size={18} strokeWidth={3} data-id="element-435" />
                  <span className="text-ink font-medium" data-id="element-436">{item}</span>
                </li>)}
            </ul>
          </div>

          <a href="#contact" className="block w-full py-4 bg-ink text-white text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-black transition-all duration-300 shadow-lg" data-id="element-437">
            Записатися на курс
          </a>
        </div>

        <div className="w-full h-px bg-line" data-id="element-438"></div>

        {/* COURSE 4: Перукар-Універсал */}
        <div className="space-y-12" data-id="element-439">
          <div className="text-center" data-id="element-440">
            <span className="inline-block px-4 py-1.5 bg-ink text-white text-xs font-semibold tracking-widest uppercase rounded-full mb-6" data-id="element-441">
              Найпопулярніший
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-ink mb-8" data-id="element-442">
              Перукар-Універсал
            </h2>
            <div className="w-full h-[300px] md:h-[400px] bg-surface rounded-[2rem] border border-line flex items-center justify-center mb-8" data-id="element-443">
              <span className="text-muted font-medium tracking-widest uppercase text-sm" data-id="element-444">
                Фото процесу
              </span>
            </div>
            <p className="bg-surface p-8 rounded-[2rem] text-muted text-lg leading-relaxed border border-line" data-id="element-445">
              Найповніша програма — стрижки + фарбування. Після курсу ви зможете
              надавати повний спектр перукарських послуг.
            </p>
          </div>

          <div className="max-w-md mx-auto bg-ink rounded-[2rem] p-10 text-center flex flex-col justify-center text-white shadow-xl" data-id="element-446">
            <p className="font-heading text-4xl md:text-5xl font-bold mb-4" data-id="element-447">
              8 000 грн <span className="text-2xl font-medium" data-id="element-448">/ міс</span>
            </p>
            <p className="text-gray-400 text-sm uppercase tracking-widest" data-id="element-449">
              Термін навчання 3 місяці
            </p>
          </div>

          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-450">
            <div className="grid md:grid-cols-2 gap-6 mb-8 pb-8 border-b border-line" data-id="element-451">
              <div className="flex items-center gap-4" data-id="element-452">
                <Calendar className="text-ink" size={24} data-id="element-453" />
                <div data-id="element-454">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-455">
                    Тривалість
                  </p>
                  <p className="font-semibold text-ink" data-id="element-456">3 місяці</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-457">
                <Clock className="text-ink" size={24} data-id="element-458" />
                <div data-id="element-459">
                  <p className="text-xs text-muted uppercase tracking-wider" data-id="element-460">
                    Тривалість уроку
                  </p>
                  <p className="font-semibold text-ink" data-id="element-461">уточнюється</p>
                </div>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-462">
              {['Стрижки + фарбування в одній програмі', 'Практика на моделях', 'Усі інструменти та матеріали надаються', 'Сертифікат після завершення', 'Підтримка після курсу'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-463">
                  <Check className="text-ink" size={18} strokeWidth={3} data-id="element-464" />
                  <span className="text-ink font-medium" data-id="element-465">{item}</span>
                </li>)}
            </ul>
          </div>

          <a href="#contact" className="block w-full py-4 bg-ink text-white text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-black transition-all duration-300 shadow-lg" data-id="element-466">
            Записатися на курс
          </a>
        </div>

        <div className="w-full h-px bg-line" data-id="element-467"></div>

        {/* COURSE 5: Манікюр та нарощування */}
        <div className="space-y-12" data-id="element-468">
          <div className="text-center" data-id="element-469">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-ink mb-4" data-id="element-470">
              Курс манікюру та нарощування нігтів
            </h2>
            <p className="text-muted text-lg mb-8" data-id="element-471">
              Для початківців. Група до 2 осіб.
            </p>
            <div className="w-full h-[300px] md:h-[400px] bg-surface rounded-[2rem] border border-line flex items-center justify-center mb-8" data-id="element-472">
              <span className="text-muted font-medium tracking-widest uppercase text-sm" data-id="element-473">
                Фото процесу
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-474">
            <div className="border border-line rounded-[2rem] p-8 flex flex-col" data-id="element-475">
              <h3 className="text-xl font-semibold text-ink mb-2" data-id="element-476">
                Базовий курс — Манікюр
              </h3>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-477">
                <span className="font-heading text-3xl font-bold text-ink" data-id="element-478">
                  3 200 грн
                </span>
                <span className="text-muted text-sm" data-id="element-479">/ 4 дні</span>
              </div>
              <ul className="space-y-3 mb-8 flex-grow text-sm text-muted" data-id="element-480">
                <li data-id="element-481">· Апаратний та комбінований манікюр</li>
                <li data-id="element-482">· Гель-лак, біогель, вирівнювання пластини</li>
                <li data-id="element-483">· Покриття близько до кутикули</li>
              </ul>
              <a href="#contact" className="block w-full py-3 border border-line text-ink text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-surface transition-all duration-300" data-id="element-484">
                Обрати
              </a>
            </div>

            <div className="bg-ink rounded-[2rem] p-8 flex flex-col text-white shadow-xl" data-id="element-485">
              <h3 className="text-xl font-semibold mb-2" data-id="element-486">
                Повний курс — Манікюр + Нарощування
              </h3>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-487">
                <span className="font-heading text-3xl font-bold" data-id="element-488">
                  4 500 грн
                </span>
                <span className="text-gray-400 text-sm" data-id="element-489">/ 6 днів</span>
              </div>
              <ul className="space-y-3 mb-8 flex-grow text-sm text-gray-300" data-id="element-490">
                <li data-id="element-491">· Все з базового курсу</li>
                <li data-id="element-492">· Нарощування — 3 техніки</li>
                <li data-id="element-493">· Стемпінг, слайдер, градієнт, французький манікюр</li>
              </ul>
              <a href="#contact" className="block w-full py-3 bg-white text-ink text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-gray-100 transition-all duration-300" data-id="element-494">
                Обрати
              </a>
            </div>
          </div>

          {/* Accordion */}
          <div className="bg-surface rounded-[2rem] border border-line overflow-hidden" data-id="element-495">
            {[{
            title: 'Теорія',
            content: 'Анатомія нігтя, обладнання, матеріали, дезінфекція, організація робочого місця'
          }, {
            title: 'Практика манікюру',
            content: 'Апаратний та комбінований манікюр, зміцнення (біогель, полігель), вирівнювання пластини, покриття'
          }, {
            title: 'Нарощування (у повному курсі)',
            content: '3 техніки нарощування, стемпінг, слайдер, градієнт, французький манікюр'
          }].map((item, index) => <div key={index} className="border-b border-line last:border-0" data-id="element-496">
                <button onClick={() => toggleAccordion(index)} className="w-full px-8 py-6 flex justify-between items-center text-left hover:bg-gray-100/50 transition-colors" data-id="element-497">
                  <span className="font-semibold text-ink text-lg" data-id="element-498">
                    {item.title}
                  </span>
                  {openAccordion === index ? <ChevronUp className="text-muted" size={20} data-id="element-499" /> : <ChevronDown className="text-muted" size={20} data-id="element-500" />}
                </button>
                <AnimatePresence data-id="element-501">
                  {openAccordion === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-502">
                      <div className="px-8 pb-6 text-muted leading-relaxed" data-id="element-503">
                        {item.content}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>

          <div className="bg-white border border-line rounded-[2rem] p-8 text-center shadow-sm" data-id="element-504">
            <p className="font-heading text-6xl font-bold text-ink mb-2" data-id="element-505">2</p>
            <p className="text-ink font-semibold text-lg mb-2" data-id="element-506">
              максимум учнів у групі
            </p>
            <p className="text-muted text-sm" data-id="element-507">
              Індивідуальний підхід до кожного
            </p>
          </div>

          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-508">
            <ul className="space-y-4" data-id="element-509">
              {['Всі інструменти та матеріали надаються', 'Тільки якісні професійні матеріали', 'Практика на різних моделях', 'Сертифікат після завершення', 'Зручний графік', 'Комфортні умови навчання'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-510">
                  <Check className="text-ink" size={18} strokeWidth={3} data-id="element-511" />
                  <span className="text-ink font-medium" data-id="element-512">{item}</span>
                </li>)}
            </ul>
          </div>

          <a href="#contact" className="block w-full py-4 bg-ink text-white text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-black transition-all duration-300 shadow-lg" data-id="element-513">
            Записатися на курс
          </a>
        </div>
      </section>

      {/* MASTER BLOCK */}
      <section className="bg-surface py-20 border-t border-line" data-id="element-514">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl flex flex-col md:flex-row items-center gap-10" data-id="element-515">
          <div className="w-40 h-40 md:w-56 md:h-56 bg-white rounded-3xl border border-line shadow-sm flex-shrink-0 flex items-center justify-center" data-id="element-516">
            <span className="text-muted font-medium tracking-widest uppercase text-xs text-center px-4" data-id="element-517">
              Портрет майстра
            </span>
          </div>
          <div data-id="element-518">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-ink mb-4" data-id="element-519">
              Ваш викладач — Валентина
            </h2>
            <p className="text-muted text-base leading-relaxed" data-id="element-520">
              Майстер-перукар та колорист з понад 12-річним досвідом. Регулярно
              підвищує кваліфікацію на міжнародних майстер-класах. Понад 300
              випускників.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section className="py-24 container mx-auto px-6 md:px-12 text-center max-w-md" data-id="element-521">
        <h2 className="font-heading text-3xl font-semibold text-ink mb-10" data-id="element-522">
          Готові почати?
        </h2>
        <div className="flex flex-col gap-4" data-id="element-523">
          <a href="#contact" className="w-full py-4 bg-ink text-white text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-black transition-all duration-300 shadow-lg" data-id="element-524">
            Записатися на курс
          </a>
          <Link to="/" className="w-full py-4 border border-line text-ink text-center text-sm font-semibold tracking-wide uppercase rounded-full hover:bg-surface transition-all duration-300" data-id="element-525">
            Повернутися на головну
          </Link>
        </div>
      </section>

      <Footer data-id="element-526" />
    </main>;
}